import { useCallback } from "react";
import useTrackerContext from "../useTrackerContext.js";
import useGlobalContext from "../useGlobalContext.js";
import useUserAgent from "../useUserAgent.js";
const ACTION_NAME = "flights.fly_anywhere_events";
const ACTION_VERSION = "1.0.0";
export const FLY_ANYWHERE_EVENT_DEFAULTS = {
    context: "",
    inbound_destination: "",
    outbound_destination: "",
    inbound_dates: "",
    outbound_dates: "",
    journey_type: "",
    cabin_class: "",
    direct: false,
    number_of_travellers: { adults: -1, children: -1 },
    trending_sorting: "",
    stops: -1,
    price: -1,
    duration: -1,
    flight_times: "",
    pages_viewed: -1,
    page: -1,
    destination_location: "",
    destination_location_id: "",
    position: -1,
    displayed_price: -1,
    currency: "",
    trip_type: ""
};
export default function useFlyAnywhereC360Events() {
    const { trackExternal } = useTrackerContext();
    const { requestId, analyticSessionId } = useGlobalContext();
    const { isMobile } = useUserAgent();
    const trackFlyAnywhereEvent = useCallback((eventName, ...args) => {
        const data = args[0];
        trackExternal({
            type: "c360",
            args: [
                {
                    action_name: ACTION_NAME,
                    action_version: ACTION_VERSION,
                    content: {
                        action_id: requestId,
                        vertical_session_id: analyticSessionId ?? "",
                        vertical: "flights",
                        event_name: eventName,
                        platform: isMobile ? "Mobile" : "Desktop",
                        ...FLY_ANYWHERE_EVENT_DEFAULTS,
                        ...data
                    }
                }
            ]
        });
    }, [trackExternal, requestId, analyticSessionId, isMobile]);
    return trackFlyAnywhereEvent;
}
